export function createLatestRequestScope() {
  let sequence = 0
  let currentKey = ''

  return {
    begin(key) {
      currentKey = String(key || '')
      sequence += 1
      return { key: currentKey, sequence }
    },
    isCurrent(request) {
      return request?.key === currentKey && request?.sequence === sequence
    },
    invalidate() {
      currentKey = ''
      sequence += 1
    },
  }
}

export function recommendationScopeKey(ownerId, anchorId) {
  return ownerId && anchorId ? `${ownerId}:${anchorId}` : ''
}
